module.exports = __webpack_public_path__ + "static/media/chevron-right-border.9261da25.svg";